import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import { actions } from "./system.actions";
import { getters } from "./system.getters";
import { mutations } from "./system.mutations";
import { state } from "./system.state";
import { SystemState } from "./system.types";

const namespaced: boolean = true;
export const SystemModule: Module<SystemState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
